import { Component, OnInit } from '@angular/core';
import { SessionStateService } from '../../../../core/services/session-state.service';

@Component({
  selector: 'app-coachmark-house-detail',
  templateUrl: './coachmark-house-detail.component.html',
  styleUrls: ['./coachmark-house-detail.component.scss']
})
export class CoachmarkHouseDetailComponent implements OnInit {
  show: boolean;
  constructor(private sessionStateService: SessionStateService) { }

  ngOnInit() {
    const waitRender = setInterval( () => {
      const elem = document.getElementsByClassName('cards')[0];
      elem.classList.add('coach');
      // const elemPosition: ClientRect = elem.getBoundingClientRect();
      // if ($('#coachmarkTips').length === 1) {
      //   $('#coachmarkTips').css('left', elemPosition.left )
      //     .css('top', elemPosition.top - window.scrollY)
      //     .css('display', 'block');
      // }
      this.show = true;
      clearInterval(waitRender);
    } , 2000);

  }

  gotIt() {
    const elem = document.getElementsByClassName('cards')[0];
    elem.classList.remove('coach');
    this.show = false;
    this.sessionStateService.setCoachMarkIndividualState(this.sessionStateService.getCoachMarkIndividualState().set('house-detail', false));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/coachmarks/coachmark-house-detail/coachmark-house-detail.component.ts